import React, { memo } from "react"
import { NewsletterForm } from "./newsletter-form";
import { MainContentFlex } from "../main-content/main-content";
import { InformationText } from "../information-text/information-text";
import { useTranslation } from "react-i18next";
const _NewsletterMainContent = () => {
    const { t } = useTranslation();
    return (
        <>
            <MainContentFlex>
                <NewsletterForm />
            </MainContentFlex>
        </>
    );

}

export const NewsletterMainContent = memo(_NewsletterMainContent);